module.exports = __webpack_public_path__ + "img/dsci0015.2716fab6.jpg";